import { useState } from 'react';
import { useRequireAdmin } from '@/lib/use-require-admin';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import BreadcrumbNavigation from '@/polymet/components/breadcrumb-navigation';
import CategoryManager from '@/polymet/components/admin/CategoryManager';
import SupplierProfileManager from '@/polymet/components/admin/SupplierProfileManager';
import UserProfileManager from '@/polymet/components/admin/UserProfileManager';

export default function AdminPage() {
  const [activeTab, setActiveTab] = useState('categories');
  const { isAdmin, loading, user } = useRequireAdmin();

  const breadcrumbItems = [
    { name: 'Home', href: '/' },
    { name: 'Admin Dashboard', href: '/admin' },
  ];

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-center h-40">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <span className="ml-3">Verifying admin access...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <BreadcrumbNavigation items={breadcrumbItems} />
        <h1 className="text-3xl font-bold mt-4">Admin Dashboard</h1>
        <p className="text-muted-foreground mt-2">
          Comprehensive platform management and administration
        </p>
      </div>

      <Tabs
        defaultValue="categories"
        value={activeTab}
        onValueChange={setActiveTab}
        className="w-full"
      >
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="categories">Category Management</TabsTrigger>
          <TabsTrigger value="supplier-profiles">Supplier Profiles</TabsTrigger>
          <TabsTrigger value="user-profiles">User Profiles</TabsTrigger>
        </TabsList>
        
        <TabsContent value="categories" className="mt-6">
          <CategoryManager />
        </TabsContent>
        
        <TabsContent value="supplier-profiles" className="mt-6">
          <SupplierProfileManager />
        </TabsContent>
        
        <TabsContent value="user-profiles" className="mt-6">
          <UserProfileManager />
        </TabsContent>
      </Tabs>
    </div>
  );
}
